import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
var App = function () {
    return (_jsxs("div", { className: "App", children: [_jsx(Navigation, {}), _jsx(Hero, {}), _jsx(About, {}), _jsx(Services, {}), _jsx(Contact, {}), _jsx(Footer, {})] }));
};
export default App;
